/*
  This file includes functions that parse floor plan
  data fetched from ADhoc Project Manager backend.
*/

// Converts bedroom type to human-readable slug
function parseTypesLabel(slug) {
  switch (slug) {
    case 'studio': return 'Studio';
    case 'one': return '1 Bedroom';
    case 'oneDen': return '1 Bedroom + Den';
    case 'two': return '2 Bedrooms';
    case 'twoDen': return '2 Bedrooms + Den';
    case 'three': return '3 Bedrooms';
    case 'threeDen': return '3 Bedrooms + Den';
    default: return slug;
  }
}

function parseTypesShortLabel(slug) {
  switch (slug) {
    case 'studio': return 'S';
    case 'one': return '1B';
    case 'oneDen': return '1B+D';
    case 'two': return '2B';
    case 'twoDen': return '2B+D';
    case 'three': return '3B';
    case 'threeDen': return '3B+D';
    default: return slug;
  }
}

function getSuiteName(suite) {
  if (suite.suite.indexOf('A') > -1 || suite.suite.indexOf('B') > -1) {
    return ((parseInt(suite.floor, 10) < 10) ? `0${parseInt(suite.floor, 10)}` : suite.floor) + suite.suite;
  }
  return ((parseInt(suite.floor, 10) < 10) ? `0${parseInt(suite.floor, 10)}` : suite.floor) +
    ((parseInt(suite.suite, 10) < 10) ? `0${parseInt(suite.suite, 10)}` : suite.suite);
}

// Converts floor plan data taken from ADhoc
// backend to our standard floor plan object.
function parseAdhocFloorplans(data) {
  const list = data.plans.map(plan => ({
    id: plan.id,
    name: plan.name,
    type: {
      label: parseTypesLabel(plan.type),
      shortLabel: parseTypesShortLabel(plan.type),
      slug: plan.type
    },
    exposure: plan.dir.split(''),
    interior: parseInt(plan.conditions[0].interior, 0),
    exterior: parseInt(plan.conditions[0].exterior, 0),
    baths: parseInt(plan.filter, 0),
    stacks: plan.conditions.map(condition => ({
      view: plan.dir.split(''),
      suiteNumber: parseInt(condition.suites[0].suite, 10),
      suites: condition.suites.map(suite => ({
        awsUnitId: null,
        floor: parseInt(suite.floor, 10),
        status: suite.status,
        name: getSuiteName(suite)
      }))
    })),
    images: {
      thumb: plan.conditions[0].images.find(img => img.type === 'thumb'),
      fp: plan.conditions[0].images.find(img => img.type === 'fp'),
      kp: plan.conditions[0].images.find(img => img.type === 'kp'),
      pdf: plan.conditions[0].images.find(img => img.type === 'pdf')
    },
    extras: plan.conditions[0].content,
    favourited: false
  }));
  list.sort((a, b) => a.interior - b.interior);
  return list;
}

function parseAwsFloorplans(list, data) {
  const allUnits = data.reduce((n, plan) => n.concat(plan.stacks), [])
    .reduce((n, stack) => n.concat(stack.units), []);

  const soldUnits = allUnits.filter(unit => unit.status !== 'available');

  list.forEach((plan) => {
    plan.stacks.forEach((stack) => {
      stack.suites.forEach((suite) => {
        const unitIndex = allUnits.findIndex(unit => unit.name === suite.name);
        if (unitIndex > -1 && suite.awsUnitId === null) {
          suite.awsUnitId = allUnits[unitIndex].id;
        }

        const soldUnitIndex = soldUnits.findIndex(unit => unit.name === suite.name);
        if (soldUnitIndex > -1) {
          suite.status = soldUnits[soldUnitIndex].status;
        }
      });
    });
  });
}

function parseViews(views) {
  const viewsList = [];
  views.forEach((view) => {
    viewsList.push({
      id: parseInt(view.id, 10),
      floor: parseInt(view.filter_id, 10),
      dir: view.title,
      src: view.url
    });
  });

  return viewsList;
}

export default {
  parseTypesLabel,
  parseAdhocFloorplans,
  parseAwsFloorplans,
  parseViews
};



// WEBPACK FOOTER //
// ./src/services/adhocParser.js